var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.order)?_c('h1',[_vm._v(_vm._s(_vm.$t('order'))+" "+_vm._s(_vm.order.reference || _vm.order.id))]):_vm._e(),(_vm.order)?_c('extra-order',{attrs:{"order":_vm.order,"errors":_vm.errors}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }